/* istanbul ignore file */

import { createAction } from '@reduxjs/toolkit';

export interface SectionVisiblePayload {
  sectionName: string;
}

export type SectionVisibleAction = ReturnType<typeof sectionVisible>;

export const getSectionVisibleActionType = (sectionName: string) =>
  `visibilityTracker/sectionVisible/${sectionName}`;

export const sectionVisible = (payload: SectionVisiblePayload) => {
  const actionType = getSectionVisibleActionType(payload.sectionName);
  const actionCreator = createAction<SectionVisiblePayload, typeof actionType>(actionType);

  return actionCreator(payload);
};
